// extracted by mini-css-extract-plugin
export default {"senceForm":"Sence_senceForm__i3026","hidden":"Sence_hidden__+FURO","switch":"Sence_switch__FsHfx"};